import { action } from './actionCreator';
import mutator from './mutator';
export function createSimpleSubscriber(decorator) {
    return function simpleSubscriber(actionType, target) {
        var simpleActionCreator = action(actionType, function simpleActionCreator() {
            return {
                args: arguments,
            };
        });
        decorator(simpleActionCreator, function simpleSubscriberCallback(actionMessage) {
            return target.apply(null, actionMessage.args);
        });
        return simpleActionCreator;
    };
}
export var mutatorAction = createSimpleSubscriber(mutator);
